/**
 * @generated SignedSource<<bb7286540aa8ad7a928014630dd36c76>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LandlordRequestDirectoryAgentClaimFailure = "AGENT_NOT_FOUND" | "%future added value";
export type LandlordRequestDirectoryAgentClaimInput = {
  agentId: string;
  email: string;
};
export type useDirectoryAgentClaimRequest_Mutation$variables = {
  input: LandlordRequestDirectoryAgentClaimInput;
  turnstileToken: string;
};
export type useDirectoryAgentClaimRequest_Mutation$data = {
  readonly landlordRequestDirectoryAgentClaim: {
    readonly claimRequestId: string | null | undefined;
    readonly failures: ReadonlyArray<LandlordRequestDirectoryAgentClaimFailure> | null | undefined;
  } | null | undefined;
};
export type useDirectoryAgentClaimRequest_Mutation = {
  response: useDirectoryAgentClaimRequest_Mutation$data;
  variables: useDirectoryAgentClaimRequest_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "turnstileToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "turnstileToken",
        "variableName": "turnstileToken"
      }
    ],
    "concreteType": "LandlordRequestDirectoryAgentClaimResponse",
    "kind": "LinkedField",
    "name": "landlordRequestDirectoryAgentClaim",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claimRequestId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failures",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDirectoryAgentClaimRequest_Mutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDirectoryAgentClaimRequest_Mutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "fbaea01d86b701884ddc5b6833dadf5f",
    "id": null,
    "metadata": {},
    "name": "useDirectoryAgentClaimRequest_Mutation",
    "operationKind": "mutation",
    "text": "mutation useDirectoryAgentClaimRequest_Mutation(\n  $input: LandlordRequestDirectoryAgentClaimInput!\n  $turnstileToken: String!\n) {\n  landlordRequestDirectoryAgentClaim(input: $input, turnstileToken: $turnstileToken) {\n    claimRequestId\n    failures\n  }\n}\n"
  }
};
})();

(node as any).hash = "23d9aa6745fe36ea7abd222ab840c588";

export default node;
